import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\ApprovalController::approve
* @see app/Http/Controllers/Admin/ApprovalController.php:46
* @route '/admin/approvals/classifieds/{classified}/approve'
*/
export const approve = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: approve.url(args, options),
    method: 'post',
})

approve.definition = {
    methods: ["post"],
    url: '/admin/approvals/classifieds/{classified}/approve',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ApprovalController::approve
* @see app/Http/Controllers/Admin/ApprovalController.php:46
* @route '/admin/approvals/classifieds/{classified}/approve'
*/
approve.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return approve.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApprovalController::approve
* @see app/Http/Controllers/Admin/ApprovalController.php:46
* @route '/admin/approvals/classifieds/{classified}/approve'
*/
approve.post = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: approve.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApprovalController::approve
* @see app/Http/Controllers/Admin/ApprovalController.php:46
* @route '/admin/approvals/classifieds/{classified}/approve'
*/
const approveForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: approve.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApprovalController::approve
* @see app/Http/Controllers/Admin/ApprovalController.php:46
* @route '/admin/approvals/classifieds/{classified}/approve'
*/
approveForm.post = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: approve.url(args, options),
    method: 'post',
})

approve.form = approveForm

/**
* @see \App\Http\Controllers\Admin\ApprovalController::reject
* @see app/Http/Controllers/Admin/ApprovalController.php:57
* @route '/admin/approvals/classifieds/{classified}/reject'
*/
export const reject = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reject.url(args, options),
    method: 'post',
})

reject.definition = {
    methods: ["post"],
    url: '/admin/approvals/classifieds/{classified}/reject',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ApprovalController::reject
* @see app/Http/Controllers/Admin/ApprovalController.php:57
* @route '/admin/approvals/classifieds/{classified}/reject'
*/
reject.url = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { classified: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { classified: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            classified: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        classified: typeof args.classified === 'object'
        ? args.classified.id
        : args.classified,
    }

    return reject.definition.url
            .replace('{classified}', parsedArgs.classified.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApprovalController::reject
* @see app/Http/Controllers/Admin/ApprovalController.php:57
* @route '/admin/approvals/classifieds/{classified}/reject'
*/
reject.post = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: reject.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApprovalController::reject
* @see app/Http/Controllers/Admin/ApprovalController.php:57
* @route '/admin/approvals/classifieds/{classified}/reject'
*/
const rejectForm = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reject.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApprovalController::reject
* @see app/Http/Controllers/Admin/ApprovalController.php:57
* @route '/admin/approvals/classifieds/{classified}/reject'
*/
rejectForm.post = (args: { classified: string | number | { id: string | number } } | [classified: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: reject.url(args, options),
    method: 'post',
})

reject.form = rejectForm

const classifieds = {
    approve: Object.assign(approve, approve),
    reject: Object.assign(reject, reject),
}

export default classifieds